import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useDirection } from "@jti/fe-common";
import { flippedRtlIcons, replacedRtlIconsMap } from "./utils";
import styles from "./Icon.module.scss";
/**
 *
 * usage:
 *
 *
 * ```jsx
 * import { Icon } from "@jti/ui";
 *
 * import Arrow from "../../assets/arrow.svg";
 *
 * const Component = () => <Icon component={Arrow} />;
 * ```
 * @deprecated use icons from @jti/brand-icons instead
 */
export const Icon = ({ component: Component, rotate, dataTestId, width = "1em", height = "1em", onClick, className = "", fill = "", restSvgProps = null, ...restProps }) => {
    const direction = useDirection();
    let IconComponent = Component;
    let shouldFlip = false;
    if (direction === "rtl") {
        IconComponent = replacedRtlIconsMap.get(Component) || Component;
        shouldFlip = flippedRtlIcons.includes(Component);
    }
    return (_jsx("span", { "aria-hidden": "true", "data-testid": dataTestId, onClick: onClick, className: classNames(styles.icon, className, { [styles.flip]: shouldFlip }), style: { transform: rotate ? `rotate(${rotate}deg)` : undefined }, ...restProps, children: _jsx(IconComponent, { ...restSvgProps, fill: fill || "currentColor", width: width, height: height }) }));
};
//# sourceMappingURL=Icon.js.map